import { XYPosition } from '@xyflow/react';
import { SECTION_NODE_PADDING } from '../const';
import { CanvasElementType } from '../canvas-types';
import { SUPPORTED_SECTIONS_DROP_ELEMENTS } from '../sections/consts';

export const getPosition = (
  start: XYPosition,
  end: XYPosition,
  canvasWrapperRef?: React.RefObject<HTMLElement>,
) => {
  const boundingRect = canvasWrapperRef?.current?.getBoundingClientRect();
  if (!boundingRect) {
    return { x: Math.min(start.x, end.x), y: Math.min(start.y, end.y) };
  }
  return {
    x: Math.min(start.x, end.x) - boundingRect.left,
    y: Math.min(start.y, end.y) - boundingRect.top,
  };
};

export const getDimensions = (start: XYPosition, end: XYPosition, zoom: number = 1) => {
  return {
    width: Math.abs(end.x - start.x) / zoom,
    height: Math.abs(end.y - start.y) / zoom,
  };
};

export const adjustNodePositionForSection = (position: XYPosition) => {
  position.x += SECTION_NODE_PADDING;
  position.y -= SECTION_NODE_PADDING;
  return position;
};

export const isSectionSupportedDropElement = (type?: CanvasElementType) => {
  if (!type) return false;
  return SUPPORTED_SECTIONS_DROP_ELEMENTS.includes(type);
};
